import type { InsightExperience } from "@/modules/community/types"
import type { ApiResponseProfile } from "@/modules/profile/api/types"

export const computeInsightsWithDefaults = (
  insights: ApiResponseProfile["experiences"][number]["insights"]
): InsightExperience["insights"] => {
  return {
    applicationProcess: "",
    companyScores: [],
    negativeFeedback: "",
    outsideWork: "",
    overallFeedback: 0,
    positiveFeedback: "",
    rawMonthlyWage: "",
    takeAways: "",
    ...insights,
  }
}
